<script lang="ts">
	import { dateToDateString } from '$lib/utils';
	import { getTranslate } from '@tolgee/svelte';
	import type { LegalPage$result } from '$houdini';

	const { t } = getTranslate();
	export let pageData: LegalPage$result['legalPage'];
</script>

<div class="x-container">
	<header class="py-24 flex flex-col items-center justify-center">
		<h1>{pageData.title}</h1>
		<h4>
			{`${$t('legal-pages.updatedAt.headline')} ${dateToDateString(pageData?.updatedAt)}`}
		</h4>
	</header>

	<div>{@html pageData?.content?.html}</div>
</div>
